var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0141 4.76814C22.523 4.77323 22.5165 5.6791 22.0076 5.67399C21.6332 5.67017 21.1362 5.83684 21.0907 5.29484C21.0429 4.72485 21.6571 4.76306 22.0141 4.76814ZM26.3891 11.6513C26.3153 12.2429 25.5482 12.1106 25.6231 11.5202C25.9171 9.1843 25.2422 6.89814 23.442 6.01255C22.9733 5.78227 23.2728 4.94384 23.7415 5.17412C25.8672 6.21993 26.7396 8.89938 26.3891 11.6513ZM3.93444 15.122L8.50365 15.1169L10.3179 10.3877C10.4666 9.99961 10.9678 10.0365 11.0514 10.492L12.832 19.047L14.8307 13.3839C14.9642 13.0048 15.4145 13.0188 15.5447 13.3814L15.5458 13.3801L16.3727 15.688L17.6509 11.716C17.7724 11.3395 18.239 11.3102 18.3768 11.7224L19.604 15.1231H24.9263C25.4341 15.1231 25.4341 16.0289 24.9263 16.0289H19.3524C19.2005 16.0315 19.0551 15.9272 18.9921 15.7516L18.034 13.0963L16.7634 17.0468C16.6386 17.4756 16.1688 17.4616 16.0353 17.0901L15.1922 14.7351L13.0958 20.6727C12.9536 21.0747 12.4513 21.034 12.3634 20.6065L10.5643 11.9626L9.10919 15.7555H9.1081C9.04734 15.9132 8.91279 16.0226 8.75546 16.0226L4.31958 16.0277C6.68072 21.1462 11.3585 25.0178 15.5003 28C19.3447 25.2315 23.237 22.0344 25.8345 17.6374C32.2093 6.84968 23.1956 -2.11243 15.7694 6.35982C15.6197 6.5303 15.381 6.53157 15.2301 6.35982C8.38007 -1.45059 0.207175 5.55576 3.93444 15.122Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking);
export default __webpack_public_path__ + "static/media/Working.db4579622d7316b8afc7a95f64374e93.svg";
export { ForwardRef as ReactComponent };